import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "components/common/desktopDataTable";
import { isMobile } from "utils/common";
import { programSearchTableHeaders, filterColumns, mobileProgramSearchTableHeaders } from "./utils";
import { displayDesktopRowItem } from "../common/desktopDataTable/utils";
import { displayMobileRowItem } from "../common/mobileDataTable/utils";
import { Link } from "react-router-dom";
import { updateSearchFilterValue } from "store/programBuilder/actionCreator";
import "./style.scss";

const SearchTable = () => {
  const dispatch = useDispatch();
  const [mobileView, setMobileView] = useState(false);
  const { programTableList, searchFilterValue } = useSelector((state) => state.programBuilder);
  const tdClass = "table-root__body__tr__td table-root__body__tr__td__text";
  useEffect(() => {
    const handleResize = () => {
      if (!isMobile()) {
        setMobileView(false);
      } else {
        setMobileView(true);
      }
    };
    window.addEventListener("resize", handleResize);
    if (isMobile()) {
      handleResize();
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileView]);

  const tempFilterList = programTableList.filter((row) => {
    const columnsTemp = filterColumns;
    return columnsTemp.some((column) => {
      const variable = row[column] == null ? "" : row[column].toString();
      return (
        variable
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase()
          .indexOf(searchFilterValue.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()) > -1
      );
    });
  });
  const filteredTableList = tempFilterList;

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    dispatch(updateSearchFilterValue(value));
  };
  const renderProgramSearchDesktopRows = (currentData) => {
    return currentData.map((row) => {
      return (
        <tr key={row.programId} className="table-root__body__tr">
          {programSearchTableHeaders.map((col, index) => {
            return (
              <>
                {col.name === "Program ID" && (
                  <td className={tdClass} key={`${row.programId}-${index}`}>
                    <Link
                      to={`/programBuilder/programDetails/${row.programId}`}
                      className="mobile-data__row__column__item__top__left__name--text customer-txt"
                    >
                      <span>{displayDesktopRowItem(row, col)}</span>
                    </Link>
                  </td>
                )}
                {col.name !== "Program ID" && (
                  <td className={tdClass} key={`${row.programId}-${index}`}>
                    {displayDesktopRowItem(row, col)}
                  </td>
                )}
              </>
            );
          })}
        </tr>
      );
    });
  };

  const renderProgramSearchMobileRows = (currentData) => {
    return currentData.map((row, index) => {
      return (
        <div className="mobile-data__row__column__item" key={index}>
          <div className="mobile-data__row__column__item__top hide-color">
            <div className="d-flex mobile-data__row__column__item__top__items">
              <div className="d-flex justify-content-between mobile-data__row__column__item__top__left ">
                <div
                  className="mobile-data__row__column__item__top__left__icon custom-collapse__container"
                  data-bs-toggle="collapse"
                  data-bs-target={"#collapse_" + row.programId + index}
                  aria-expanded="false"
                  aria-controls={"#collapse_" + row.programId + index}
                >
                  <span className="expand-collapse"></span>
                </div>
              </div>
              <div className="mobile-data__row__column__item__top__left__name">
                <span className="mobile-data__row__column__item__top__left__name--text">
                  {"Program ID - " + row.programId}
                </span>
              </div>
            </div>
          </div>
          <div className="collapse mobile-data__row__column__item__content" id={"collapse_" + row.programId + index}>
            {mobileProgramSearchTableHeaders &&
              mobileProgramSearchTableHeaders.map((item, i) => {
                return (
                  <div key={i} className={`mobile-data__row__column__item__content__item ${item.classNameOne}`}>
                    <div className="mobile-data__row__column__item__content__item__flex">
                      <div className="mobile-data__row__column__item__content__item__flex--key">{item.keyName}:</div>
                      <div
                        className={`mobile-data__row__column__item__content__item__flex--value ${
                          item?.classNameTwo ? item.classNameTwo : ""
                        }`}
                      >
                        <span>{item.key}</span>
                        {item.keyName === "Program ID" ? (
                          <Link
                            to={`/programBuilder/programDetails/${row.programId}`}
                            className="mobile-data__row__column__item__top__left__name--text customer-txt"
                          >
                            <span>{displayMobileRowItem(row, item)}</span>
                          </Link>
                        ) : (
                          displayMobileRowItem(row, item)
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
    });
  };
  return (
    <>
      <DataTable
        tableHeader={programSearchTableHeaders}
        tableBody={programTableList}
        renderDesktopRows={renderProgramSearchDesktopRows}
        renderMobileRows={renderProgramSearchMobileRows}
        countTitle="Search Results"
        displaySearchFilter={true}
        displaySectionTwo={true}
        filteredTableList={filteredTableList}
        searchFilterValue={searchFilterValue}
        handleSearchFilter={handleSearchFilter}
        expandedItems={mobileProgramSearchTableHeaders}
        parentComponent={"programBuilder"}
      />
    </>
  );
};

export default SearchTable;
